import { render } from "./DigitalProductStore.vue.js?vue&type=template&id=c63e5604!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DigitalProductStore.vue?vue&type=template&id=c63e5604"
import script from "./DigitalProductStore.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DigitalProductStore.vue?vue&type=script&lang=js"
export * from "./DigitalProductStore.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DigitalProductStore.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/DigitalProductStore.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c63e5604"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c63e5604', __exports__)) {
    api.reload('c63e5604', __exports__)
  }
  
  module.hot.accept("./DigitalProductStore.vue.js?vue&type=template&id=c63e5604!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DigitalProductStore.vue?vue&type=template&id=c63e5604", () => {
    api.rerender('c63e5604', render)
  })

}


export default __exports__